/** @jsxImportSource @emotion/react */

import React from 'react';
import { useTypedDispatch } from '@hook/common/useStore';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import { useFindMe } from '@hook/auth/useAuth';
import Home from '@component/iyagigo/hub/home';
import PageTemplate from '@page/iyagigo/page-template';

const HubHomePage: React.FC<any> = () => {
  return (
    <PageTemplate title='설정' mode={'page'}>
      <Home />
    </PageTemplate>
  );
};

export default HubHomePage;
